import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import DataEntry from "@/pages/DataEntry";
import HashtagMaster from "@/pages/HashtagMaster";
import LocationManager from "@/pages/LocationManager";
import KnowledgeBrowser from "@/pages/KnowledgeBrowser";
import GovernanceReplay from "@/pages/GovernanceReplay";
import GoldenQuestions from "@/pages/GoldenQuestions";
import LLMSpend from "@/pages/LLMSpend";
import CustomerMemory from "@/pages/CustomerMemory";
import Gatekeeper from "@/pages/Gatekeeper";
import SOPs from "@/pages/SOPs";
import LLMKeyAdmin from "@/pages/LLMKeyAdmin";
import Chat from "@/pages/Chat";
import VoiceChat from "@/pages/VoiceChat";
import RealtimeVoiceChat from "@/pages/RealtimeVoiceChat";
import AdminLayout from "@/components/AdminLayout";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="mono-label pulse-soft">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/chat" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/admin"
            element={
              <Protected adminOnly>
                <AdminLayout />
              </Protected>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="data-entry" element={<DataEntry />} />
            <Route path="archive" element={<KnowledgeBrowser />} />
            <Route path="governance" element={<GovernanceReplay />} />
            <Route path="golden" element={<GoldenQuestions />} />
            <Route path="spend" element={<LLMSpend />} />
            <Route path="memory" element={<CustomerMemory />} />
            <Route path="gatekeeper" element={<Gatekeeper />} />
            <Route path="sops" element={<SOPs />} />
            <Route path="llm-keys" element={<LLMKeyAdmin />} />
            <Route path="locations" element={<LocationManager />} />
            <Route path="hashtags" element={<HashtagMaster />} />
          </Route>
          <Route
            path="/chat"
            element={
              <Protected>
                <Chat />
              </Protected>
            }
          />
          <Route
            path="/voice-chat"
            element={
              <Protected>
                <VoiceChat />
              </Protected>
            }
          />
          <Route
            path="/voice-live"
            element={
              <Protected>
                <RealtimeVoiceChat />
              </Protected>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
